import api from '@motionelements/core/src/api/base-api-v2';

// eslint-disable-next-line import/prefer-default-export
export const subscribeFreeEdm = async (payload, axiosConfig) => {
  const post = await api.request('post', '/v2/edm/free', {
    ...(axiosConfig || {}), // for recaptcha headers
    params: api.getLocaleParams(),
    data: payload,
  });
  return post;
};
